<template>
  <div class="admin-dashboard">
    <div class="wrap">
      <div class="list-group">
        <div class="list">
          <list-item v-for="diary in diaries" :item=diary link_prefix="/admin/diary/" v-bind:key=diary.key></list-item>
        </div>
      </div>    
    </div>
  </div>
</template>
<script>
import ListItem from '../common/ListItem'
export default {
  components: { ListItem },
  data: () => {
    return {
    }
  },
  computed: {
    diaries() {
      return this.$store.state.diaries
    },
  },
  created: function() {
    this.$store.dispatch('fetchDiaries')
  }
}
</script>
